import { useCallback } from "react";

export const useCSVExport = () => {
  const convertToCSV = useCallback(
    (data: any[], filename: string = "export.csv") => {
      if (!data || data.length === 0) {
        return;
      }

      const headers = Object.keys(data[0]);

      const csvContent = [
        headers.join(","),
        ...data.map((row) =>
          headers
            .map((header) => {
              const value = row[header];
              if (
                typeof value === "string" &&
                (value.includes(",") ||
                  value.includes('"') ||
                  value.includes("\n"))
              ) {
                return `"${value.replace(/"/g, '""')}"`;
              } else if (typeof value === "object") {
                return JSON.stringify(value);
              }
              return value ?? "";
            })
            .join(","),
        ),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    },
    [],
  );

  const exportToCSV = useCallback(
    (data: any[], filename?: string) => {
      convertToCSV(data, filename);
    },
    [convertToCSV],
  );

  return {
    exportToCSV,
  };
};
